import { render, staticRenderFns } from "./SocioEconomic.vue?vue&type=template&id=eccee446&"
import script from "./SocioEconomic.vue?vue&type=script&lang=js&"
export * from "./SocioEconomic.vue?vue&type=script&lang=js&"
import style0 from "./SocioEconomic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SocioEconomic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports